export class TrilhaDeAuditoriaTabela {
  id: number;
  id_trilha_de_auditoria: number;
  nome_tabela: string;
}



// WEBPACK FOOTER //
// ./src/app/entity/trilha_de_auditoria_tabela.model.ts